import { isTextEmpty } from '../../../_shared/utils/text/text.helpers';

export const validateMapAccessPassword = (password: string): boolean => {
  return !isTextEmpty(password);
};
